import { routePaths, IRoute } from "./routePaths";
import { ImpersonationLogin } from "../../../components/authentication/impersonation/ImpersonationLogin";
import { EmployeesAdministration } from "../../../components/administration/employeesAdministration/employeesList/EmployeesAdministrationList";
import { EmployeesAdministrationEmployee } from "../../../components/administration/employeesAdministration/employee/EmployeesAdministrationEmployee";
import { EmployeeWizard } from "../../../components/administration/employeesAdministration/employeeWizard/EmployeeWizard";
import { PlansAdministration } from "../../../components/administration/plansAdministration/plansList/PlansList";
import { PlansAdministrationPlan } from "../../../components/administration/plansAdministration/plan/PlansAdministrationPlan";
import { PlanWizard } from "../../../components/administration/plansAdministration/planWizard/PlanWizard";
import { PreReservationFormNomenclature } from "../../../components/nomenclatures/preReservationForm/PreReservationFormNomenclature";
import { UsersAdministration } from "../../../components/administration/usersAdministration/usersList/UsersAdministrationList";
import { UserAdministrationUser } from "../../../components/administration/usersAdministration/user/UserAdministrationUser";
import { UserWorkoutsPage } from "../../../components/administration/usersAdministration/user/workouts/UserWorkoutsPage";
import { UserBodyMetricsPage } from "../../../components/administration/usersAdministration/user/bodyMetrics/UserBodyMetricsPage";
import { UserGoalsPage } from "../../../components/administration/usersAdministration/user/goals/UserGoalsPage";
import { UserWizard } from "../../../components/administration/usersAdministration/userWizard/UserWizard";
import { EventWizard } from "../../../components/planner/eventWizard/EventWizard";
import { PlannerEvent } from "../../../components/planner/event/PlannerEvent";
import { NavigationItems } from "./navigationItems";
import { TenantWizard } from "../../../components/administration/tenantsAdministration/tenantWizard/TenantWizard";
import { TenantsList } from "../../../components/administration/tenantsAdministration/tenantsList/TenantsList";
import { TenantsAdministrationTenant } from "../../../components/administration/tenantsAdministration/tenant/TenantsAdministrationTenant";
import { StudioWizard } from "../../../components/administration/studiosAdministration/studioWizard/StudioWizard";
import { StudiosList } from "../../../components/administration/studiosAdministration/studiosList/StudiosList";
import { StudiosAdministrationStudio } from "../../../components/administration/studiosAdministration/studio/StudiosAdministrationStudio";
import { PlannerEventSignUp } from "../../../components/planner/signUp/PlannerEventSignUp";
import { NewPassword } from "../../../components/newPassword/NewPassword";
import { endpointsMetadata } from "./endpointsMetadata";
import { ErrorPage } from "../../components/errorPages/ErrorPage";
import { ServerErrorPage } from "../../components/errorPages/ServerErrorPage";
import { Statistics } from "../../../components/statistics/Statistics";
import { ViewStatistics } from "../../../components/statistics/ViewStatistics";
import { NoStudiosFound } from "../../components/errorPages/NoStudiosFound";
import { EventArrivalConfirmation } from "../../../components/planner/eventArrivalConfirmation/EventArrivalConfirmation";
import { StudioRelationsList } from "../../../components/administration/studioRelations/studioRelationsList/StudioRelationsList";
import { StudioRelationsWizard } from "../../../components/administration/studioRelations/studioRelationsWizard/StudioRelationsWizard";
import { FamiliesList } from "../../../components/administration/familiesAdministration/familiesList/FamiliesList";
import { FamilyWizard } from "../../../components/administration/familiesAdministration/familyWizard/FamilyWizard";
import { FamiliesAdministrationFamily } from "../../../components/administration/familiesAdministration/family/FamiliesAdministrationFamily";
import { TestPage } from "../../../components/TestPage";
import { Authenticate } from "../../../components/authentication/Authenticate";
import { MyReservations } from "../../../components/portal/myReservations/MyReservations";
import { ReservationSuccess } from "../../../components/portal/calendar/components/ReservationSuccess/ReservationSuccess";
import { MyFamily } from "../../../components/portal/myFamily/MyFamily";
import { MyFamilyWizard } from "../../../components/portal/myFamily/MyFamilyWizard/MyFamilyWizard";
import { MyPlans } from "../../../components/portal/myPlans/MyPlans";
import { MyWorkouts } from "../../../components/portal/myWorkouts/MyWorkouts";
import { MyBodyMetrics } from "../../../components/portal/myBodyMetrics/MyBodyMetrics";
import { MyGoals } from "../../../components/portal/myGoals/MyGoals";
import { MyConsents } from "../../../components/portal/myConsents/MyConsents";
import { MyProfile } from "../../../components/portal/myProfile/MyProfile";
import { AppointmentWizard } from "../../../components/portal/appointment/AppointmentWizard";
import { GroupClassWizard } from "../../../components/portal/groupClassWizard/GroupClassWizard";
import { WaitingListConfirmation } from "../../../components/portal/waitingListConfirmation/WaitingListConfirmation";
import { StudioPlanTypesNomenclature } from "../../../components/nomenclatures/studioPlanType/StudioPlanTypesNomenclature";
import { StudioHallTypesNomenclature } from "../../../components/nomenclatures/studioHallType/StudioHallTypesNomenclature";
import { SubscriptionPlan } from "../../../components/common/userPlan/subscriptionPlan/SubscriptionPlan";
import { RefillCard } from "../../../components/common/userPlan/refillCard/RefillCard";
import { Login } from "../../../components/common/login/Login";
import { ForgottenPassword } from "../../../components/common/forgottenPassword/ForgottenPassword";
import { Logout } from "../../../components/common/logout/Logout";
import { CalendarRouter } from "../../../components/common/calendarRouter/CalendarRouter";
import GoogleOAuth from "../../../components/authentication/externalAuth/GoogleOAuth";
import GoogleOAuthSuccess from "../../../components/authentication/externalAuth/GoogleOAuthSuccess";
import { BreakTypesNomenclature } from "../../../components/nomenclatures/breakType/BreakTypesNomenclature";
import { ServiceTypesNomenclature } from "../../../components/nomenclatures/serviceType/ServiceTypesNomenclature";
import { EventTypeCategoriesNomenclature } from "../../../components/nomenclatures/eventTypeCategory/EventTypeCategoriesNomenclature";
import { InventoryNomenclature } from "../../../components/nomenclatures/inventory/InventoryNomenclature";
import { CashdeskPage } from "../../../components/cashdesk/CashdeskPage";
import { GymPage } from "../../../components/gym/GymPage";
import { InventoryTransfersPage } from "../../../components/inventory/transfers/InventoryTransfersPage";
import { InventoryOverviewPage } from "../../../components/inventory/overview/InventoryOverviewPage";
import { Dashboard } from "../../../components/Dashboard";
import { StudioNotFound } from "../../components/errorPages/StudioNotFound";
import { CommunicationLogs } from "../../../components/administration/communicationLogs/CommunicationLogs";
import { InvoicesList } from "../../../components/administration/invoices/InvoicesList";
import { GiftVouchersPage } from "../../../components/administration/giftVouchers/GiftVouchersPage";
import { StudioReviewsPage } from "../../../components/administration/reviews/StudioReviewsPage";
import { ReviewInvitePage } from "../../../components/reviews/invite/ReviewInvitePage";
import { PaymentResult } from "../../../components/common/paymentResult/PaymentResult";
import { PublicStudioLinkPage } from "../../../components/linkPage/PublicStudioLinkPage";
import { FillClientFormPage } from "../../../components/portal/fillClientForm/FillClientFormPage";
import { SupportList } from "../../../components/support/list/SupportList";
import { SupportChat } from "../../../components/support/chat/SupportChat";
import { SupportHome } from "../../../components/support/home/SupportHome";
import { StudioFeatureRoute } from "./components/StudioFeatureRoute";
import {
  studioHidesPlans,
  studioHidesWorkouts,
  studioHidesBodyMetrics,
  studioHidesGoals,
} from "../helpers/studioHelper";

const studios: IRoute[] = [
  {
    name: "Обекти",
    path: routePaths.studios,
    navigationItem: NavigationItems.Studios,
    authenticationEndpoint: endpointsMetadata.studio.getAll,
    element: <StudiosList />,
  },
  {
    name: "Профил на обект",
    path: routePaths.studioSingle,
    navigationItem: NavigationItems.Studios,
    authenticationEndpoint: endpointsMetadata.studio.getStudio,
    element: <StudiosAdministrationStudio />,
    showBackButton: true,
    backFallbackPath: routePaths.studios,
  },
  {
    name: "Добавяне на обект",
    path: routePaths.studioAdd,
    navigationItem: NavigationItems.Studios,
    authenticationEndpoint: endpointsMetadata.studio.wizard,
    element: <StudioWizard pageMode="add" />,
  },
  {
    name: "Редактиране на обект",
    path: routePaths.studioEdit,
    navigationItem: NavigationItems.Studios,
    authenticationEndpoint: endpointsMetadata.studio.wizard,
    element: <StudioWizard pageMode="edit" />,
  },
];

const tenants: IRoute[] = [
  {
    name: "Бизнес клиенти",
    path: routePaths.tenants,
    navigationItem: NavigationItems.Tenants,
    authenticationEndpoint: endpointsMetadata.tenant.getAll,
    element: <TenantsList />,
  },
  {
    name: "Профил на бизнес клиент",
    path: routePaths.tenantSingle,
    navigationItem: NavigationItems.Tenants,
    authenticationEndpoint: endpointsMetadata.tenant.getTenant,
    element: <TenantsAdministrationTenant />,
    showBackButton: true,
    backFallbackPath: routePaths.tenants,
  },
  {
    name: "Добавяне на бизнес клиент",
    path: routePaths.tenantAdd,
    navigationItem: NavigationItems.Tenants,
    authenticationEndpoint: endpointsMetadata.tenant.wizard,
    element: <TenantWizard pageMode={"add"} />,
  },
  {
    name: "Редактиране на бизнес клиент",
    path: routePaths.tenantEdit,
    navigationItem: NavigationItems.Tenants,
    authenticationEndpoint: endpointsMetadata.tenant.wizard,
    element: <TenantWizard pageMode={"edit"} />,
  },
];

const employees: IRoute[] = [
  {
    name: "Служители",
    path: routePaths.employees,
    navigationItem: NavigationItems.Employees,
    authenticationEndpoint: endpointsMetadata.employee.getAll,
    element: <EmployeesAdministration />,
  },
  {
    name: "Профил на служител",
    path: routePaths.employeeSingle,
    navigationItem: NavigationItems.Employees,
    authenticationEndpoint: endpointsMetadata.employee.getEmployee,
    element: <EmployeesAdministrationEmployee />,
    showBackButton: true,
    backFallbackPath: routePaths.employees,
  },
  {
    name: "Добяване на служител",
    path: routePaths.employeeAdd,
    navigationItem: NavigationItems.Employees,
    authenticationEndpoint: endpointsMetadata.employee.wizard,
    element: <EmployeeWizard pageMode="add" />,
  },
  {
    name: "Редактиране на служител",
    path: routePaths.employeeEdit,
    navigationItem: NavigationItems.Employees,
    authenticationEndpoint: endpointsMetadata.employee.wizard,
    element: <EmployeeWizard pageMode="edit" />,
  },
];

const plans: IRoute[] = [
  {
    name: "Планове",
    path: routePaths.plans,
    navigationItem: NavigationItems.Plans,
    authenticationEndpoint: endpointsMetadata.plan.getAll,
    element: (
      <StudioFeatureRoute isHidden={studioHidesPlans}>
        <PlansAdministration />
      </StudioFeatureRoute>
    ),
  },
  {
    name: "Детайли за план",
    path: routePaths.planSingle,
    navigationItem: NavigationItems.Plans,
    authenticationEndpoint: endpointsMetadata.plan.getPlan,
    element: (
      <StudioFeatureRoute isHidden={studioHidesPlans}>
        <PlansAdministrationPlan />
      </StudioFeatureRoute>
    ),
    showBackButton: true,
    backFallbackPath: routePaths.plans,
  },
  {
    name: "Добавяне на план",
    path: routePaths.planAdd,
    navigationItem: NavigationItems.Plans,
    authenticationEndpoint: endpointsMetadata.plan.wizard,
    element: (
      <StudioFeatureRoute isHidden={studioHidesPlans}>
        <PlanWizard pageMode="add" />
      </StudioFeatureRoute>
    ),
  },
  {
    name: "Редактиране на план",
    path: routePaths.planEdit,
    navigationItem: NavigationItems.Plans,
    authenticationEndpoint: endpointsMetadata.plan.wizard,
    element: (
      <StudioFeatureRoute isHidden={studioHidesPlans}>
        <PlanWizard pageMode="edit" />
      </StudioFeatureRoute>
    ),
  },
];

const forms: IRoute[] = [
  {
    name: "Форми",
    path: routePaths.forms,
    navigationItem: NavigationItems.Forms,
    authenticationEndpoint:
      endpointsMetadata.preReservationFormNomenclature.getAll,
    element: <PreReservationFormNomenclature />,
  },
];

const families: IRoute[] = [
  {
    name: "Семейства",
    path: routePaths.families,
    navigationItem: NavigationItems.Families,
    authenticationEndpoint: endpointsMetadata.family.getAll,
    element: <FamiliesList />,
  },
  {
    name: "Детайли за семейство",
    path: routePaths.familySingle,
    navigationItem: NavigationItems.Families,
    authenticationEndpoint: endpointsMetadata.family.getFamily,
    element: <FamiliesAdministrationFamily />,
    showBackButton: true,
    backFallbackPath: routePaths.families,
  },
  {
    name: "Добавяне на семейство",
    path: routePaths.familyAdd,
    navigationItem: NavigationItems.Families,
    authenticationEndpoint: endpointsMetadata.family.wizard,
    element: <FamilyWizard pageMode="add" />,
  },
  {
    name: "Редактиране на семейство",
    path: routePaths.familyEdit,
    navigationItem: NavigationItems.Families,
    authenticationEndpoint: endpointsMetadata.family.wizard,
    element: <FamilyWizard pageMode="edit" />,
  },
];

const users: IRoute[] = [
  {
    name: "Потребители",
    path: routePaths.users,
    navigationItem: NavigationItems.Users,
    authenticationEndpoint: endpointsMetadata.user.getAll,
    element: <UsersAdministration />,
  },
  {
    name: "Профил на потребител",
    path: routePaths.userSingle,
    navigationItem: NavigationItems.Users,
    authenticationEndpoint: endpointsMetadata.user.getUser,
    element: <UserAdministrationUser />,
    showBackButton: true,
    backFallbackPath: routePaths.users,
  },
  {
    name: "Тренировки на потребител",
    path: routePaths.userWorkouts,
    navigationItem: NavigationItems.Users,
    authenticationEndpoint: endpointsMetadata.workoutPlan.getUserWorkoutsDetailed,
    element: (
      <StudioFeatureRoute isHidden={studioHidesWorkouts}>
        <UserWorkoutsPage />
      </StudioFeatureRoute>
    ),
    showBackButton: true,
    backFallbackPath: routePaths.users,
  },
  {
    name: "Метрики на потребител",
    path: routePaths.userBodyMetrics,
    navigationItem: NavigationItems.Users,
    authenticationEndpoint: endpointsMetadata.bodyMetric.getUserBodyMetrics,
    element: <UserBodyMetricsPage />,
    showBackButton: true,
    backFallbackPath: routePaths.users,
  },
  {
    name: "Цели на потребител",
    path: routePaths.userGoals,
    navigationItem: NavigationItems.Users,
    authenticationEndpoint: endpointsMetadata.goal.getUserGoals,
    element: (
      <StudioFeatureRoute isHidden={studioHidesGoals}>
        <UserGoalsPage />
      </StudioFeatureRoute>
    ),
    showBackButton: true,
    backFallbackPath: routePaths.users,
  },
  {
    name: "Добавяне на потребител",
    path: routePaths.userAdd,
    navigationItem: NavigationItems.Users,
    authenticationEndpoint: endpointsMetadata.user.wizard,
    element: <UserWizard pageMode="add" />,
  },
  {
    name: "Редактиране на потребител",
    path: routePaths.userEdit,
    navigationItem: NavigationItems.Users,
    authenticationEndpoint: endpointsMetadata.user.wizard,
    element: <UserWizard pageMode="edit" />,
  },
  {
    name: "Абонаментен план",
    path: routePaths.userPlan,
    navigationItem: NavigationItems.Users,
    authenticationEndpoint: endpointsMetadata.user.getUserPlan,
    // Not behind the plans toggle: the reports and the dashboard still link to sold cards.
    element: <SubscriptionPlan />,
    showBackButton: true,
    backFallbackPath: routePaths.users,
  },
  {
    name: "Зареждане на карта",
    path: routePaths.userRefillCard,
    navigationItem: NavigationItems.CardRefill,
    authenticationEndpoint: endpointsMetadata.plan.refillCard,
    element: (
      <StudioFeatureRoute isHidden={studioHidesPlans}>
        <RefillCard pageMode="add" />
      </StudioFeatureRoute>
    ),
  },
  {
    name: "Редактиране на абонамент",
    path: routePaths.userPlanEdit,
    navigationItem: NavigationItems.CardRefill,
    authenticationEndpoint: endpointsMetadata.plan.wizardRefillCardInitialData,
    element: (
      <StudioFeatureRoute isHidden={studioHidesPlans}>
        <RefillCard pageMode="edit" />
      </StudioFeatureRoute>
    ),
  },
];

const planner: IRoute[] = [
  {
    name: "Календар",
    path: routePaths.calendar,
    navigationItem: NavigationItems.PlannerCalendar,
    authenticationEndpoint: endpointsMetadata.planner.getAll,
    element: <CalendarRouter />,
  },
  {
    name: "Потвърждение за присъствие",
    path: routePaths.plannerEventArrivalConfirmation,
    navigationItem: NavigationItems.PlannerCalendar,
    authenticationEndpoint: endpointsMetadata.planner.markUserAsArrived,
    element: <EventArrivalConfirmation />,
  },
  {
    name: "Преглед на клас",
    path: routePaths.plannerEvent,
    navigationItem: NavigationItems.PlannerCalendar,
    authenticationEndpoint: endpointsMetadata.planner.getEvent,
    element: <PlannerEvent />,
    showBackButton: true,
    backFallbackPath: routePaths.calendar,
  },
  {
    name: "Добавяне на клас",
    path: routePaths.plannerAdd,
    navigationItem: NavigationItems.PlannerCalendar,
    authenticationEndpoint: endpointsMetadata.planner.wizard,
    element: <EventWizard pageMode="add" />,
  },
  {
    name: "Записване за клас",
    path: routePaths.plannerEventSignUp,
    navigationItem: NavigationItems.PlannerCalendar,
    authenticationEndpoint: endpointsMetadata.planner.registerForEvent,
    element: <PlannerEventSignUp pageMode={"add"} />,
  },
  {
    name: "Редактиране на запис за клас",
    path: routePaths.plannerEventEditSignUp,
    navigationItem: NavigationItems.PlannerCalendar,
    authenticationEndpoint: endpointsMetadata.planner.registerForEvent,
    element: <PlannerEventSignUp pageMode={"edit"} />,
  },
  {
    name: "Редактиране на клас",
    path: routePaths.plannerEdit,
    navigationItem: NavigationItems.PlannerCalendar,
    authenticationEndpoint: endpointsMetadata.planner.wizard,
    element: <EventWizard pageMode="edit" />,
  },
  {
    name: "Клониране на клас",
    path: routePaths.plannerEventDuplication,
    navigationItem: NavigationItems.PlannerCalendar,
    authenticationEndpoint: endpointsMetadata.planner.wizard,
    element: <EventWizard pageMode="duplicate" />,
  },
];

const communicationLogs: IRoute[] = [
  {
    name: "SMS | Email логове",
    path: routePaths.communicationLogs,
    navigationItem: NavigationItems.CommunicationLogs,
    authenticationEndpoint: endpointsMetadata.communicationLogs.getEmailLogs,
    element: <CommunicationLogs />,
  },
];

const invoices: IRoute[] = [
  {
    name: "Фактури",
    path: routePaths.invoices,
    navigationItem: NavigationItems.Invoices,
    authenticationEndpoint: endpointsMetadata.invoice.getForTenant,
    element: <InvoicesList />,
  },
];

const giftVouchers: IRoute[] = [
  {
    name: "Подаръчни ваучери",
    path: routePaths.giftVouchers,
    navigationItem: NavigationItems.GiftVouchers,
    authenticationEndpoint: endpointsMetadata.giftVoucher.getAll,
    element: <GiftVouchersPage />,
  },
];

const studioReviews: IRoute[] = [
  {
    name: "Ревюта",
    path: routePaths.studioReviews,
    navigationItem: NavigationItems.StudioReviews,
    authenticationEndpoint: endpointsMetadata.studioReviews.getAll,
    element: <StudioReviewsPage />,
  },
];

const studioRelations: IRoute[] = [
  {
    name: "Свързани обекти",
    path: routePaths.studioRelations,
    navigationItem: NavigationItems.StudioRelations,
    authenticationEndpoint:
      endpointsMetadata.studioRelations.getAllEligibleStudios,
    element: <StudioRelationsList />,
  },
  {
    name: "Добавяне на свързан обект",
    path: routePaths.studioRelationsAdd,
    navigationItem: NavigationItems.StudioRelations,
    authenticationEndpoint:
      endpointsMetadata.studioRelations.addStudioConnection,
    element: <StudioRelationsWizard />,
  },
];

const portal: IRoute[] = [
  {
    name: "Моят профил",
    path: routePaths.portalMyProfile,
    authenticationEndpoint: endpointsMetadata.authentication.getUserProfile,
    element: <MyProfile />,
  },
  {
    name: "Начало",
    path: routePaths.portalAppointment,
    navigationItem: NavigationItems.PortalCalendar,
    isPublic: true,
    authenticationEndpoint: endpointsMetadata.appointments.appointmentWizard,
    element: <AppointmentWizard />,
  },
  {
    // The "Как беше?" e-mail lands here; the token in the link identifies the client.
    name: "Ревю",
    path: routePaths.review,
    isPublic: true,
    element: <ReviewInvitePage />,
  },
  {
    name: "Резервация на групов клас",
    path: routePaths.portalGroupClassWizard,
    navigationItem: NavigationItems.PortalCalendar,
    isPublic: true,
    authenticationEndpoint: endpointsMetadata.groupClasses.reserve,
    element: <GroupClassWizard />,
  },
  {
    name: "Потвърждение на място от списъка на чакащите",
    path: routePaths.confirmWaitingList,
    navigationItem: NavigationItems.PortalCalendar,
    isPublic: true,
    element: <WaitingListConfirmation />,
  },
  {
    name: "Календар",
    path: routePaths.calendar,
    navigationItem: NavigationItems.PortalCalendar,
    authenticationEndpoint: endpointsMetadata.portalCalendar.getAll,
    isPublic: true,
    element: <CalendarRouter />,
  },
  {
    name: "Успешна резервация",
    path: routePaths.portalReservationSuccess,
    navigationItem: NavigationItems.PortalCalendar,
    isPublic: true,
    element: <ReservationSuccess />,
  },
  {
    name: "Моите резервации",
    path: routePaths.portalMyReservations,
    navigationItem: NavigationItems.MyReservations,
    authenticationEndpoint: endpointsMetadata.myReservations.getAll,
    element: <MyReservations />,
  },
  {
    name: "Моето семейство",
    path: routePaths.portalMyFamily,
    navigationItem: NavigationItems.MyFamily,
    authenticationEndpoint: endpointsMetadata.myFamily.getCurrentUserFamily,
    element: <MyFamily />,
  },
  {
    name: "Създаване на семейство",
    path: routePaths.portalMyFamilyAdd,
    navigationItem: NavigationItems.MyFamily,
    authenticationEndpoint: endpointsMetadata.myFamily.updateFamily,
    element: <MyFamilyWizard pageMode="add" />,
  },
  {
    name: "Редактиране на семейство",
    path: routePaths.portalMyFamilyEdit,
    navigationItem: NavigationItems.MyFamily,
    authenticationEndpoint: endpointsMetadata.myFamily.updateFamily,
    element: <MyFamilyWizard pageMode="edit" />,
  },
  {
    name: "Моите планове",
    path: routePaths.portalMyPlans,
    navigationItem: NavigationItems.MyPlans,
    authenticationEndpoint: endpointsMetadata.myPlans.getAll,
    element: (
      <StudioFeatureRoute isHidden={studioHidesPlans}>
        <MyPlans />
      </StudioFeatureRoute>
    ),
  },
  {
    name: "Моите тренировки",
    path: routePaths.portalMyWorkouts,
    navigationItem: NavigationItems.MyWorkouts,
    authenticationEndpoint: endpointsMetadata.workoutPlan.getMyWorkouts,
    element: (
      <StudioFeatureRoute isHidden={studioHidesWorkouts}>
        <MyWorkouts />
      </StudioFeatureRoute>
    ),
  },
  {
    name: "Моите метрики",
    path: routePaths.portalMyBodyMetrics,
    navigationItem: NavigationItems.MyBodyMetrics,
    authenticationEndpoint: endpointsMetadata.bodyMetric.getMyBodyMetrics,
    element: (
      <StudioFeatureRoute isHidden={studioHidesBodyMetrics}>
        <MyBodyMetrics />
      </StudioFeatureRoute>
    ),
  },
  {
    name: "Моите цели",
    path: routePaths.portalMyGoals,
    navigationItem: NavigationItems.MyGoals,
    authenticationEndpoint: endpointsMetadata.goal.getMyGoals,
    element: (
      <StudioFeatureRoute isHidden={studioHidesGoals}>
        <MyGoals />
      </StudioFeatureRoute>
    ),
  },
  {
    name: "Моите съгласия",
    path: routePaths.portalMyConsents,
    navigationItem: NavigationItems.MyConsents,
    authenticationEndpoint: endpointsMetadata.myConsents.getAll,
    element: <MyConsents />,
  },
];

const nomenclatures: IRoute[] = [
  {
    name: "Типове планове",
    path: routePaths.nomenclaturePlanTypes,
    navigationItem: NavigationItems.PlanTypes,
    authenticationEndpoint:
      endpointsMetadata.studioPlanTypesNomenclature.getAll,
    element: (
      <StudioFeatureRoute isHidden={studioHidesPlans}>
        <StudioPlanTypesNomenclature />
      </StudioFeatureRoute>
    ),
  },
  {
    name: "Зали",
    path: routePaths.nomenclatureHalls,
    navigationItem: NavigationItems.Halls,
    authenticationEndpoint: endpointsMetadata.studioHallTypeNomenclature.getAll,
    element: <StudioHallTypesNomenclature />,
  },
  {
    name: "Типове блокирания",
    path: routePaths.nomenclatureBreakType,
    navigationItem: NavigationItems.BreakTypes,
    authenticationEndpoint: endpointsMetadata.breakTypeNomenclature.getAll,
    element: <BreakTypesNomenclature />,
  },
  {
    name: "Типове услуги",
    path: routePaths.nomenclatureServiceType,
    navigationItem: NavigationItems.ServiceTypes,
    authenticationEndpoint: endpointsMetadata.serviceTypeNomenclature.getAll,
    element: <ServiceTypesNomenclature />,
  },
  {
    name: "Категории за класове",
    path: routePaths.nomenclatureEventTypeCategory,
    navigationItem: NavigationItems.EventTypeCategories,
    authenticationEndpoint:
      endpointsMetadata.eventTypeCategoryNomenclature.getAll,
    element: <EventTypeCategoriesNomenclature />,
  },
  {
    name: "Наличности",
    path: routePaths.inventoryOverview,
    navigationItem: NavigationItems.InventoryOverview,
    authenticationEndpoint:
      endpointsMetadata.inventoryOverview.getExpiringBatches,
    element: <InventoryOverviewPage />,
  },
  {
    name: "Продукти",
    path: routePaths.inventoryProducts,
    navigationItem: NavigationItems.InventoryProducts,
    authenticationEndpoint:
      endpointsMetadata.inventoryItemNomenclature.getAllWithDeleted,
    element: <InventoryNomenclature />,
  },
  {
    name: "Доставки",
    path: routePaths.inventoryTransfers,
    navigationItem: NavigationItems.InventoryTransfers,
    authenticationEndpoint: endpointsMetadata.inventoryTransfers.getAll,
    element: <InventoryTransfersPage />,
  },
];

// The static "/support/..." paths stay above "/support/:id": the Layout's BackButton takes the
// first route whose path matches, and ":id" also matches "tickets" and "new".
const support: IRoute[] = [
  {
    name: "Помощ",
    path: routePaths.support,
    navigationItem: NavigationItems.Support,
    authenticationEndpoint: endpointsMetadata.supportChat.getAll,
    element: <SupportHome />,
  },
  {
    name: "Запитвания",
    path: routePaths.supportTickets,
    navigationItem: NavigationItems.Support,
    authenticationEndpoint: endpointsMetadata.supportChat.getAll,
    element: <SupportList />,
    backFallbackPath: routePaths.support,
  },
  {
    name: "Ново запитване",
    path: routePaths.supportNew,
    navigationItem: NavigationItems.Support,
    authenticationEndpoint: endpointsMetadata.supportChat.getAll,
    element: <SupportChat isNew />,
    backFallbackPath: routePaths.supportTickets,
  },
  {
    name: "Запитване",
    path: routePaths.supportChat,
    navigationItem: NavigationItems.Support,
    authenticationEndpoint: endpointsMetadata.supportChat.getAll,
    element: <SupportChat />,
    backFallbackPath: routePaths.supportTickets,
  },
];

export const routesMetadata: IRoute[] = [
  ...studios,
  ...tenants,
  ...employees,
  ...plans,
  ...forms,
  ...families,
  ...users,
  ...planner,
  ...studioRelations,
  ...communicationLogs,
  ...invoices,
  ...giftVouchers,
  ...studioReviews,
  ...portal,
  ...nomenclatures,
  {
    name: "Каса",
    path: routePaths.cashdesk,
    navigationItem: NavigationItems.Cashdesk,
    authenticationEndpoint: endpointsMetadata.cashdesk.getOrders,
    element: <CashdeskPage />,
  },
  {
    name: "Зала",
    path: routePaths.gym,
    navigationItem: NavigationItems.Gym,
    authenticationEndpoint: endpointsMetadata.gym.stats,
    element: <GymPage />,
  },
  ...support,
  // {
  //   name: "Начало",
  //   path: routePaths.home,
  //   element: <></>,
  // },
  {
    name: "Табло",
    path: routePaths.dashboard,
    navigationItem: NavigationItems.Dashboard,
    authenticationEndpoint: endpointsMetadata.dashboard.getMetrics,
    element: <Dashboard />,
  },
  {
    name: "Репорти",
    path: routePaths.statistics,
    navigationItem: NavigationItems.Statistics,
    authenticationEndpoint: endpointsMetadata.statistics.generateStatistics,
    element: <Statistics />,
  },
  {
    name: "Репорти",
    path: routePaths.viewStatistics,
    navigationItem: NavigationItems.Statistics,
    authenticationEndpoint: endpointsMetadata.statistics.generateStatistics,
    element: <ViewStatistics />,
    showBackButton: true,
    backFallbackPath: routePaths.statistics,
  },
  {
    name: "Вход",
    path: routePaths.login,
    navigationItem: NavigationItems.Login,
    isPublic: true,
    element: <Authenticate />,
  },
  {
    name: "Вход",
    path: routePaths.admin,
    isPublic: true,
    element: <Login />,
  },
  {
    name: "Вход с Google",
    path: routePaths.googleOAuth,
    isPublic: true,
    element: <GoogleOAuth />,
  },
  {
    name: "Вход с Google",
    path: routePaths.googleOAuthSuccess,
    isPublic: true,
    element: <GoogleOAuthSuccess />,
  },
  {
    name: "Забравена папрола",
    path: routePaths.resetPassword,
    isPublic: true,
    element: <ForgottenPassword />,
  },
  {
    name: "Отписване",
    path: routePaths.logout,
    navigationItem: NavigationItems.Logout,
    element: <Logout />,
  },
  {
    name: "Задаване на нова парола",
    path: routePaths.setPassword,
    isPublic: true,
    element: <NewPassword />,
  },
  {
    name: "Грешка",
    path: routePaths.errorPage,
    element: <ErrorPage />,
  },
  {
    name: "Сървърна грешка",
    path: routePaths.serverErrorPage,
    isPublic: true,
    element: <ServerErrorPage />,
  },
  {
    name: "Няма добавени обекти",
    path: routePaths.noStudiosFoundPage,
    element: <NoStudiosFound />,
  },
  {
    name: "Обектът не е намерен",
    path: routePaths.invalidDomain,
    isPublic: true,
    element: <StudioNotFound />,
  },
  {
    name: "Резултат от плащане",
    path: routePaths.paymentResult,
    isPublic: true,
    element: <PaymentResult />,
  },
  {
    name: "Линк страница",
    path: routePaths.studioLinkPage,
    isPublic: true,
    isStandalone: true,
    element: <PublicStudioLinkPage />,
  },
  {
    // A form staff emailed to a client from their profile. Standalone: the client is often
    // not logged in (or has no password yet), and the studio dialogs would only get in the way.
    name: "Попълване на форма",
    path: routePaths.fillClientForm,
    isPublic: true,
    isStandalone: true,
    element: <FillClientFormPage />,
  },
  {
    // The admin panel's "log into this profile" link. Standalone, so none of the previous
    // session's studio dialogs open while the ticket is being redeemed.
    name: "Вход в профил от админ панела",
    path: routePaths.impersonate,
    isPublic: true,
    isStandalone: true,
    element: <ImpersonationLogin />,
  },
  {
    name: "Настройки",
    path: routePaths.settings,
    // TODO
    // authenticationEndpoint: endpointsMetadata.user.wizard,
    // TODO
    element: <></>,
  },
  {
    name: "Test",
    path: routePaths.testPage,
    navigationItem: NavigationItems.StudioRelations,
    element: <TestPage />,
  },
];
